import module from 'app/module.js'
import template from './template.html'

const correoRegx = '^[^@]+@[^@]+\.[a-zA-Z]{2,}$'

export class UsuarioSolicitudRestablecerComponent {

  finalizo = false
  error = null
  correoRegx = correoRegx
  email = null
  onlyOne = false

  constructor (UsuarioReestablecer) {
    this.UsuarioReestablecer = UsuarioReestablecer
  }

  enviar () {

    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.UsuarioReestablecer.get(this.email)
      .then(() => {
        this.finalizo = true
        this.onlyOne = true
      })
      .catch((error) => (this.error = error.data || error))
      .finally(() => (this.procesando = false))
  }
}

module.component('usuarioSolicitudReestablecer', {
  controller: UsuarioSolicitudRestablecerComponent,
  template,
  bindings: {
    idUsuario: '<',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/restablecer/solicitud/component.js